import LocomotiveScroll from 'locomotive-scroll';

class Scroll {

    constructor() {
		this.locomotiveContainer = document.querySelector('[data-scroll-container]')
    }
  
    init() {
		this.setupLocomotive()
    }
  
    setupLocomotive () {

		new LocomotiveScroll({
			el: this.locomotiveContainer
		});

	}

  }
  
  export default Scroll
  